import { callApi } from "./api";
import { getQueryString, getOffsetLimitFromPagination } from "../utils/query";

class ReportTypesService {
  async getReportTypesPaged({
    currentPage,
    pageSize,
    searchValue,
    cancelToken,
    orderValue,
  }) {
    if (orderValue !== "") {
      searchValue = "";
      currentPage = 1;
    }
    const query = getQueryString({
      ...getOffsetLimitFromPagination({ currentPage, pageSize }),
      search: searchValue,
      ordering: orderValue ? orderValue : "-date_edited",
    });
    const result = await callApi({
      url: `/api/report_types/${query}`,
      cancelToken,
    });

    return result;
  }

  async addReportType(data) {
    return await callApi({
      url: `/api/report_types/`,
      method: "POST",
      data,
    });
  }

  async getAllReportTypes() {
    const result = await callApi({
      url: `/api/report_types/?limit=1000`,
      method: "GET",
    });
    if (result.results) {
      result.results.map((elem) => {
        if (!elem.tax) {
          elem.tax = elem.ex_tax;
        }
        return elem;
      });
    }
    return result;
  }
  async getAllReportTypesSpecialization() {
    const result = await callApi({
      url: `/api/report_types/?limit=10000`,
      method: "GET",
    });
    if (result.results) {
      result.results.map((elem) => {
        if (!elem.tax) {
          elem.tax = elem.ex_tax;
        }
        return elem;
      });
    }
    return result;
  }

  async editReportType(id, data) {
    if (isNaN(data.tax)) {
      data.ex_tax = data.tax;
      data.tax = null;
    }
    return await callApi({
      url: `/api/report_types/${id}/`,
      method: "PATCH",
      data,
    });
  }

  async deleteReportType(id) {
    return await callApi({
      url: `/api/report_types/${id}/`,
      method: "DELETE",
    });
  }
  async getSpecializations(id) {
    return await callApi({
      url: `/api/specializations/?limit=1000`,
      method: "GET",
    });
  }
}

export const reportTypesService = new ReportTypesService();
